/* eslint-disable no-undef */
import TwitterConv from 'react-twitter-conversion-tracker'

export default () => {
	if (!TWITTER_PIXEL_ID) return
	TwitterConv.init(TWITTER_PIXEL_ID)
	TwitterConv.pageView()
}
